import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { DeleteTenantMutation, Tenant, TenantInput } from '#/graphql/types';
import { deleteTenant } from '#/graphql/mutations';
import { get, omit, pick } from 'lodash';

const q = gql(deleteTenant);

const useTenantDelete = () => {
  const [mutation, result] = useMutation<DeleteTenantMutation>(q);
  const deleteTenant = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
      });

      return get(response, 'data.deleteTenant', undefined);
    },
    [mutation],
  );

  return { deleteTenant, result };
};
// Used in the modules ModuleDataGrid file
export default useTenantDelete;
